module.exports = __webpack_public_path__ + "img/feature-ico-3.d42e12ea.svg";